import React from 'react';
import styled from 'styled-components';
import { BaseButton, BaseButtonWrapper } from './BaseButton';

export const BaseSkeletonButtonWrapper = styled.div`
  button {
    padding: 12px 24px;
    width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
    max-width: ${({ $fullWidth }) => ($fullWidth ? '420px' : 'auto')};
  }
`;

// A SkeletonButton used as a TOGGLE gets a visible selected state.
//
// `aria-pressed` already reached the <button> — BaseButton spreads buttonProps — but nothing ever
// styled it, so every toggle built on this component announced its state to a screen reader and
// showed nothing at all to everyone else: the date-window presets, the backfill status chips, the
// column chooser, the missing-only filter and the sample-feed switch. Selected inverts to the
// filled treatment, which reads as a state change by lightness and not by hue alone.
//
// A button that never passes `aria-pressed` is not a toggle and is untouched by any of this.
export const SkeletonButtonWrap = styled(BaseSkeletonButtonWrapper)`
  ${BaseButtonWrapper} {
    background: transparent;
    border: ${({ theme }) => `1px solid ${theme.themeColors.primaryCtaButton}`};

    * {
      color: ${({ theme }) => theme.themeColors.primaryCtaButton};
      fill: ${({ theme }) => theme.themeColors.primaryCtaButton};
    }

    :hover {
      opacity: 0.8;
    }
  }

  ${BaseButtonWrapper}[aria-pressed='true'] {
    background: ${({ theme }) => theme.themeColors.primaryCtaButton};

    * {
      color: ${({ theme }) => theme.themeColors.buttonText};
      fill: ${({ theme }) => theme.themeColors.buttonText};
    }
  }
`;

export const DisabledButtonWrap = styled(BaseSkeletonButtonWrapper)`
  ${BaseButtonWrapper} {
    background: ${({ theme }) => theme.themeColors.primaryCtaButton};
    border: ${({ theme }) => '1px solid ' + theme.themeColors.primaryCtaButton};

    opacity: 0.45;
    cursor: not-allowed;

    * {
      color: ${({ theme }) => theme.themeColors.buttonText};
      fill: ${({ theme }) => theme.themeColors.buttonText};
    }

    :hover {
      cursor: not-allowed;
      opacity: 0.4;
    }
  }
`;

export const SkeletonButton = (props) => {
  const { children, buttonProps, disabled, onClick, fullWidth } = props;

  if (disabled) {
    return (
      <DisabledButtonWrap $fullWidth={fullWidth}>
        <BaseButton {...buttonProps} onClick={onClick}>
          <b>{children}</b>
        </BaseButton>
      </DisabledButtonWrap>
    );
  }

  return (
    <SkeletonButtonWrap $fullWidth={fullWidth}>
      <BaseButton {...buttonProps} onClick={onClick}>
        <b>{children}</b>
      </BaseButton>
    </SkeletonButtonWrap>
  );
};

SkeletonButton.defaultProps = {
  buttonProps: {},
};
